import { render, staticRenderFns } from "./build.vue?vue&type=template&id=46e9c0f8&scoped=true"
import script from "./build.vue?vue&type=script&lang=js"
export * from "./build.vue?vue&type=script&lang=js"
import style0 from "./build.vue?vue&type=style&index=0&id=46e9c0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9c0f8",
  null
  
)

export default component.exports